// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles__logo--3dd7U","animating":"styles__animating--3v9gv","spin":"styles__spin--3us7p"};